
/**
 * 공통 기본 엔티티 정보
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOf = {
  /** 생성 일시 */
  createdAt: string;
  /** 고유 식별자 */
  id: number;
  /** 수정 일시 */
  updatedAt?: string;
};
